import MobileOffIcon from '@mui/icons-material/MobileOff';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {
  AccountBox,
  List,
  Payments,
  PermContactCalendar,
  PersonRemove,
  Place,
  ScheduleSend,
  Settings,
  Widgets,
  Logout,
  GridViewOutlined,
  Science
} from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import { isTestingEnvironment } from 'src/shared/utils/isTestingEnvironment';

export default t => [
  {
    id: uuidv4(),
    title: t('items.all holdings'),
    href: '/super/holdings',
    icon: List
  },
  {
    id: uuidv4(),
    icon: Settings,
    title: t('subheaders.settings'),
    items: [
      {
        id: uuidv4(),
        title: t('items.super admin list'),
        href: '/super/list-super-admins',
        icon: AccountBox
      },
      {
        id: uuidv4(),
        title: t('items.global limits'),
        href: '/super/global-limits',
        icon: Place
      },
      {
        id: uuidv4(),
        title: t('items.hub'),
        href: '/super/hub/territories',
        icon: GridViewOutlined
      }
    ]
  },
  {
    id: uuidv4(),
    icon: Payments,
    title: t('subheaders.payments'),
    items: [
      {
        id: uuidv4(),
        title: t('items.post cycle transactions'),
        href: '/super/post-cycle-transactions',
        icon: ScheduleSend
      },
      {
        id: uuidv4(),
        title: t('items.manage transactions'),
        href: '/super/manage-transactions',
        icon: Widgets
      }
    ]
  },
  {
    id: uuidv4(),
    icon: NotificationsIcon,
    title: t('subheaders.ops'),
    items: [
      {
        id: uuidv4(),
        title: t('items.alerts'),
        href: '/super/alerts',
        icon: NotificationsIcon
      },
      {
        id: uuidv4(),
        title: t('items.dummify'),
        href: '/super/dummify',
        icon: PersonRemove
      },
      {
        id: uuidv4(),
        title: t('items.change personal id'),
        href: '/super/change/personal-id',
        icon: PermContactCalendar
      },
      {
        id: uuidv4(),
        title: t('items.emergency switch-off'),
        href: '/super/emergency',
        icon: MobileOffIcon
      }
    ]
  },
  ...(isTestingEnvironment()
    ? [
        {
          id: uuidv4(),
          icon: Science,
          title: t('subheaders.sandbox'),
          items: [
            {
              id: uuidv4(),
              title: t('items.sandbox payments'),
              href: '/super/sandbox/payments',
              icon: Payments
            }
          ]
        }
      ]
    : []),
  {
    id: uuidv4(),
    title: t('items.logout'),
    action: 'logout',
    icon: Logout
  }
];
